<template>
    <Button v-bind="$attrs" variant="outline" v-on="$listeners">
        <template v-for="(_, slot) in $slots" v-slot:[slot]>
            <slot :name="slot" />
        </template>
    </Button>
</template>

<script>
import Button from './Button';

export default {
    name: 'DsOutlineButton',
    components: { Button },
    inheritAttrs: false,
};
</script>
